export default "__VITE_ASSET__vgRkg9$k__"